<template>
  <section>
    <template v-if="professional.status === 1">
      <hr>
      <h3 class="text-body">
        {{ $t('message.professional.about_your_cleaner') }}
        {{ professional.name | firstName }}
      </h3>
      <div class="professional-short-description" v-if="professional.short_description">
        {{ professional.short_description }}
      </div>
      <div class="mb-1 text-long">
        <span v-if="$i18n.locale === 'th'">{{ professional.description | stripSlashes }}</span>
        <span v-else>{{ professional.description_en | stripSlashes }}</span>
      </div>
      <template v-if="professional.service_ids.indexOf(16) === -1">
      <hr>
      <h3 class="text-body">{{ $t('message.professional.my_services') }}</h3>
      <div class="">
        <div class="cleaner-equipment" v-if="professional.service_ids.includes(1)">
          <img src="/static/img/ic-cleaning.svg">
          <span v-html="$options.filters.serviceParentName(1, globalState.services)"></span>
        </div>
        <div class="cleaner-equipment" v-if="professional.service_ids.includes(2)">
          <img src="/static/img/ic-ironing.svg">
          <span v-html="$options.filters.serviceParentName(2, globalState.services)"></span>
        </div>
        <div class="cleaner-equipment" v-if="professional.service_ids.includes(39)">
          <img src="/static/img/ic-bathroom.svg">
          <span v-html="$options.filters.serviceParentName(39, globalState.services)"></span>
        </div>
      </div>
      </template>
      <template v-if="professional.professional_districts && professional.professional_districts.length > 0">
        <hr>
        <h3 class="text-body">{{ $t('message.professional.service_areas') }}</h3>
        <div class="row">
          <div class="col-12 p-0">
            <span v-for="districtData, index in professional.professional_districts">
              {{ districtData.district | multiLangName  }}{{ (index + 1) === professional.professional_districts.length ? '' : ', ' }}
            </span>
          </div>
        </div>
        <div class="card mt-3 rounded-all" style="background-color: #FDF8E0;">
          <div class="card-body p-2 d-flex justify-content-start align-items-top">
            <div>
              <i class="fal fa-exclamation-circle text-danger"></i>
            </div>
            <div class="pl-2">
              {{ $t('message.professional.service_areas_remark') }}
            </div>
          </div>
        </div>
        <div class="card mt-3 rounded-all" style="background-color: #FDF8E0;" v-if="getPetTypes()">
          <div class="card-body p-2 d-flex justify-content-start align-items-top">
            <div>
              <img id="badge-inconvenient-pet"
                   src="/static/img/badge-inconvenient-pet.svg"
                   alt=""
                   width="24">
            </div>
            <div class="pl-2">
              {{ $t('message.professional.inconvenient_pet') }}<br>
              <strong>{{ getPetTypes() }}</strong>
            </div>
          </div>
        </div>
      </template>
      <template v-if="professional.transportation_type">
        <hr>
        <h3 class="text-body">{{ $t('message.professional.transportation_type') }}</h3>
        <span v-html="$options.filters.transportationTypeIcon(professional.transportation_type)"></span>
        {{ professional.transportation_type | multiLangName }}
      </template>
      <hr>
      <h3 class="text-body">{{ $t('message.professional.spoken_languages') }}</h3>
      <div class="row">
        <div class="col-12 p-0">
          {{ professional.spoken_languages }}
        </div>
      </div>
      <template v-if="professional.service_ids.indexOf(1) !== -1">
        <hr>
        <h3 class="text-body">{{ $t('message.professional.what_i_will_provide') }}</h3>
        <div class="d-flex flex-row">
          <div class="cleaner-equipment" v-if="professional.has_vacuum_cleaner">
            <img src="/static/img/ic-vacuum.svg">
            {{ $t('message.professional.vacuum_cleaner') }}
          </div>
          <div class="cleaner-equipment">
            <img src="/static/img/ic-cleaning-equipment.svg">
            {{ $t('message.professional.cleaning_equipment') }}
          </div>
        </div>
      </template>
      <template v-if="professional.service_ids.indexOf(1) !== -1 || professional.service_ids.indexOf(1) !== -16">
        <hr>
        <h3 class="text-body">{{ $t('message.professional.cleaning_skills') }}</h3>
        <cleaner-skills/>
      </template>
      
    </template>
    <template v-else>
      <div class="space-top-16 text-center">
        <h3>
          <i class="fas fa-exclamation-triangle text-orange"></i>
          {{ $t('message.professional.not_available') }}
        </h3>
      </div>
    </template>
  </section>
</template>

<script>
  import CleanerSkills from '../components/CleanerSkills'
  import { mapGetters } from 'vuex'
  import professionalHelpers from '../../../helpers/professionalHelpers'

  export default {
    props: ['professional'],
    components: {
      CleanerSkills
    },
    computed: {
      ...mapGetters({
        globalState: 'globalVal/getState'
      })
    },
    methods: {
      getPetTypes () {
        const pets = professionalHelpers.getInconvenientPets(this.professional)
        return pets
      }
    }
  }
</script>

<style scoped>
  .fal {
    font-size: 120%;
  }
</style>



// WEBPACK FOOTER //
// src/components/professional/components/CleanerDescriptionSection.vue